<template>
  <div>
    <header-com></header-com>
    <van-nav-bar
      title="会员权益"
      left-text="返回"
      left-arrow
      @click-left="onTopClickLeft"
      class="custom-navbar"
    >
      <a
        :href="
          routeValue === null ||
          routeValue === undefined ||
          routeValue.length === 0
            ? 'https://www.ptty.com.cn/wap/#/'
            : 'https://www.ptty.com.cn/wap/#/' + routeValue
        "
        slot="right"
        style="font-size:20px;"
      >
        <van-icon style="font-size:20px;" name="wap-home" />
      </a>
    </van-nav-bar>

    <div class="content-container">
      <!-- 会员标题卡片 -->
      <div class="header-card">
        <div class="vip-icon">
          <van-icon name="vip-card" size="48" color="#FF6B00" />
        </div>
        <h2 class="title">会员权益</h2>
        <p class="subtitle">专属特权，助力成长</p>
        <div class="price-section">
          <div class="promotion-badge">
            <span class="badge-text">🎉 会员免费注册</span>
          </div>
          <div class="price-tag">
            <span class="original-price">¥19.9/年</span>
            <span class="free-price">2026全年限时免费</span>
          </div>
        </div>
      </div>

      <!-- 权益列表 -->
      <div class="benefits-list">
        <div class="benefit-item">
          <div
            class="benefit-icon"
            style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);"
          >
            <van-icon name="friends-o" size="28" color="#fff" />
          </div>
          <div class="benefit-content">
            <h3 class="benefit-title">多运动员绑定</h3>
            <p class="benefit-desc">
              可绑定多位运动员，生成详细的生涯报告和成长轨迹，全方位记录每一次进步
            </p>
          </div>
        </div>

        <div class="benefit-item">
          <div
            class="benefit-icon"
            style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);"
          >
            <van-icon name="coupon-o" size="28" color="#fff" />
          </div>
          <div class="benefit-content">
            <h3 class="benefit-title">入会礼包</h3>
            <p class="benefit-desc">
              首次入会，赠送星耀商城优惠券，精选装备优惠购
            </p>
          </div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="footer-tip">
        <p class="tip-text">更多会员权益，敬请期待</p>
      </div>
    </div>

    <!-- 底部支付按钮 -->
    <div class="payment-footer">
      <div class="payment-info">
        <div class="payment-price">
          <span class="price-label">会员费用：</span>
          <span class="original-price-small">¥19.9/年</span>
        </div>
      </div>
      <van-button
        type="primary"
        size="large"
        round
        class="payment-button"
        @click="handlePayment"
      >
        立即免费开通
      </van-button>
    </div>

    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { HeaderCom, LoadingCom },
  name: "MemberBenefits",
  data() {
    return {
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
  },
  methods: {
    onTopClickLeft() {
      this.$router.go(-1);
    },
    handlePayment() {
      // 检查登录状态
      const openIdEn = localStorage.getItem("openIdEn");
      if (!openIdEn) {
        this.$toast("请先登录");
        this.$router.push("/loginIndex");
        return;
      }

      const ryInfoLocal = localStorage.getItem("ryInfo");
      if (!ryInfoLocal) {
        this.$toast("请先登录");
        this.$router.push("/loginIndex");
        return;
      }

      // 确认支付
      this.$dialog
        .confirm({
          title: "开通会员",
          message:
            "2026年全年免费开通会员，原价 ¥19.9/年，现在免费！确认开通？",
          confirmButtonText: "确认开通",
          cancelButtonText: "取消"
        })
        .then(() => {
          // 调用支付接口
          this.processPayment();
        })
        .catch(() => {
          // 用户取消
        });
    },
    processPayment() {
      // 调用后端 confirmHyHandler 方法开通会员
      const busData = {};
      const paramData = {
        headerData: {
          ssid: "",
          op: "wapGL",
          methodName: "confirmHyHandler"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          if (!data.isSuccess) {
            this.$toast.fail(data.msg || "开通失败");
            return;
          }

          // 开通成功
          this.$toast.success("会员开通成功！");

          // 更新本地存储的会员状态
          const ryInfoLocal = localStorage.getItem("ryInfo");
          if (ryInfoLocal) {
            try {
              const ryInfo = JSON.parse(ryInfoLocal);
              ryInfo.isHy = "1"; // 更新会员状态
              localStorage.setItem("ryInfo", JSON.stringify(ryInfo));
            } catch (e) {
              console.error("更新会员状态失败:", e);
            }
          }

          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            this.$router.push("/meQygjIndex");
          }, 1500);
        })
        .catch(error => {
          console.error("开通会员失败:", error);
          this.$toast.fail("开通失败，请重试");
        });
    }
  }
};
</script>

<style scoped>
/* 全局容器 */
.content-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  padding: 16px 16px 80px;
}

/* 导航栏 */
.custom-navbar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 头部卡片 */
.header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 32px 20px;
  text-align: center;
  margin-bottom: 20px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.25);
}

.vip-icon {
  margin-bottom: 16px;
}

.title {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin: 0;
}

/* 价格标签 */
.price-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.promotion-badge {
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  padding: 6px 16px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  animation: badgePulse 2s ease-in-out infinite;
}

.badge-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@keyframes badgePulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(255, 215, 0, 0.6);
  }
}

.price-tag {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  padding: 12px 24px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.original-price {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 500;
  text-decoration: line-through;
  text-decoration-thickness: 2px;
}

.free-price {
  color: #ffd700;
  font-size: 28px;
  font-weight: 700;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: priceShine 2s ease-in-out infinite;
}

@keyframes priceShine {
  0%,
  100% {
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  50% {
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(255, 215, 0, 0.6);
  }
}

.price-symbol {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-right: 2px;
}

.price-number {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
}

.price-unit {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  margin-left: 4px;
}

/* 权益列表 */
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.benefit-item {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.3s;
}

.benefit-item:active {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.benefit-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.benefit-content {
  flex: 1;
}

.benefit-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.benefit-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

/* 底部提示 */
.footer-tip {
  margin-top: 32px;
  text-align: center;
  margin-bottom: 20px;
}

.tip-text {
  color: #999;
  font-size: 13px;
  margin: 0;
}

/* 底部支付区域 */
.payment-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 16px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 12px;
}

.payment-info {
  flex: 1;
}

.payment-price {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.price-label {
  font-size: 14px;
  color: #666;
}

.original-price-small {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
  text-decoration-thickness: 1.5px;
}

.free-price-large {
  font-size: 18px;
  font-weight: 700;
  color: #ff6b00;
  background: linear-gradient(135deg, #ff6b00 0%, #ff8c00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.promotion-tip {
  font-size: 12px;
  color: #ff6b00;
  font-weight: 500;
}

.price-value {
  font-size: 20px;
  font-weight: 700;
  color: #ff6b00;
}

.payment-button {
  flex-shrink: 0;
  width: 160px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.payment-button:active {
  transform: scale(0.98);
}

/* 响应式调整 */
@media (max-width: 375px) {
  .header-card {
    padding: 24px 16px;
  }

  .title {
    font-size: 22px;
  }

  .benefit-item {
    padding: 16px;
  }

  .benefit-icon {
    width: 48px;
    height: 48px;
  }

  .benefit-title {
    font-size: 15px;
  }

  .benefit-desc {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/MemberBenefits.vue